import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'infra-interaction_to_next_paint-view';

/**
 * General event for capturing the Interaction To Next Paint (INP) metric.
 */
export function trackInfraInteractionToNextPaintView(
  name: string,
  loadType2: string,
  inp3: string,
  attribution4: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { name, loadType2, inp3, attribution4 },
  });
}
